<template>
  <div class="container">
    <dl class="price-row">
      <dt class="price-label">Your Price</dt>
      <div class="price-amount">{{ formatMoney(productPrice) }}</div>
    </dl>
    <div class="disclaimer-row">
      <p>Credit is prorated from the date of this order until current subscription(s) expiration.</p>
    </div>
  </div>
</template>

<script>
import formatMoneyMixin from "@/mixins/formatMoneyMixin";
export default {
  name: "ProductPrice",
  props: {
    productPrice: {
      type: Number,
      required: true
    }
  },
  mixins: [formatMoneyMixin]
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/mixins.scss';
@import "../assets/styles/variables";
.container {
  padding: 1rem 2rem;
  background: var(--tmf-dk-blue);
  color: var(--tmf-yellow);
  border-bottom-right-radius: $border-radius;
}
.price-row {
  @include line-item-style;
}
.price-amount {
  font-size: 1.5em;
}
.disclaimer-row {
  p {
    @include note-text;
  }
}
@media (max-width: $mobile-breakpoint) {
  .container {
    border-bottom-left-radius: $border-radius;
  }
}
</style>
